import { useEffect, useRef, useState } from 'react';

export const useHoverWithDelayedExit = (
	delay: number = 3000,
	initiallyHovered: boolean = false,
) => {
	const [isHovered, setIsHovered] = useState(initiallyHovered);
	const hasInteractedRef = useRef(false);
	const timerRef = useRef<number | null>(null);

	const handleMouseEnter = () => {
		if (!hasInteractedRef.current) {
			hasInteractedRef.current = true;
		}
		if (timerRef.current) {
			window.clearTimeout(timerRef.current);
			timerRef.current = null;
		}
		setIsHovered(true);
	};

	const handleMouseLeave = () => {
		if (!hasInteractedRef.current) {
			return;
		}
		if (timerRef.current) {
			window.clearTimeout(timerRef.current);
		}
		timerRef.current = window.setTimeout(() => setIsHovered(false), delay);
	};

	useEffect(() => {
		return () => {
			if (timerRef.current) {
				window.clearTimeout(timerRef.current);
			}
		};
	}, []);

	return { isHovered, handleMouseEnter, handleMouseLeave };
};
